import axios, { AxiosResponse } from 'axios';

import { EProfilyTyp } from 'enums/profilyTyp';

export enum ETypPrihlaseni {
    PXKLIC = 'PXKLIC',
    CERT = 'CERT',
    UZIV = 'UZIV',
    BI = 'BI',
    DLT = 'DLT'
}

export interface IProfily {
    jmeno: string;
    prijmeni: string;
    id: string;
    email: string;
    email2: string;
    telefon1: string;
    telefon2: string;
    stavudaju?: 'OK' | 'CHYBA';
    typprihlaseni?: ETypPrihlaseni;
    cerdn?: string;
    cerissuer?: string;
    sezpristupu?: IPristupy[];
    posledniprihlaseni?: string;
    datumregistrace?: string;
}

export interface IPristupy {
    poradi?: number;
    iducet: number;
    stav: 'AKTIVNI' | 'SKRYTY' | 'NEAKTIVNI';
    typ: EProfilyTyp;
    ic?: string;
    nid?: string;
    spolecnost?: string;
    lei?: string;
    profil?: string;
    spravauziv?: boolean;
    osoba?: string;
    email?: string;
    telefon?: string;
    adresa?: string;
    seznotifikaci?: ISeznamNotifikaci[];
    stat?: string;
    useroid?: number;
    emitentprava?: {
        vypis?: string;
        upis?: string;
        srd?: string;
        adminwr?: string;
        upissicav?: boolean | string;
    };
}

export interface ISeznamNotifikaci {
    typ: 'ZELENE' | 'CERVENE' | 'ZLUTE';
    typText: string;
    text: string;
}

const profilyApi = (filter?: string, jinaOsoba?: boolean) => {
    return axios({
        method: 'GET',
        url: `Portal/Profily${jinaOsoba ? '?jinaosoba=true' : filter ? '?filter=' + filter : ''}`
    }).then((resp: AxiosResponse<IProfily>) => resp);
};
export default profilyApi;
